var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowTopScroll = function SvgArrowTopScroll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 2.5c0 .275.225.5.5.5h13a.5.5 0 1 0 0-1h-13a.5.5 0 0 0-.5.5ZM11.876 22a.625.625 0 0 0 .625-.625V6.635l3.932 3.933a.626.626 0 0 0 .885-.885l-5-5a.625.625 0 0 0-.885 0l-5 5a.626.626 0 1 0 .886.885l3.932-3.933v14.74a.625.625 0 0 0 .625.625Z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowTopScroll;